<template>
  <el-table-column
    prop="product_name"
    label="Terméknév"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.product_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'product_name',
};
</script>
